export const AssignmentTypes = ['SPECIFIC', 'TOURNEE'] as const;
export type AssignmentType = (typeof AssignmentTypes)[number];

const ASSIGNMENT_TYPE_LABELS: Record<AssignmentType, string> = {
  SPECIFIC: 'Spécifique',
  TOURNEE: 'Tournée',
};

export function assignmentTypeLabel(type: AssignmentType): string {
  return ASSIGNMENT_TYPE_LABELS[type];
}
